import SuperAgent from 'superagent'
import {api_root} from '@src/index.js'
import {errorHandling, unauthorizedRedirect} from './error.handler.js'
import {getBearerAccessToken} from "./authenticate";
import {store} from '_helpers/store'
import {alertActions} from '_actions'

export const deviceService = {
  getDeviceConfig,
  deployDevice,
  getDeviceLogs,
  getDeviceEvents,
  getErrorOverview,
  syncTreatments,
  getDeviceStateV2,
  getDeviceSwVersion,
  getDeviceXenionData,
  getDeviceMapData,
  waitOnEvent,
  releaseControl,
  takeControl,
  stopImmediately,
  uploadIncidentData,
  uploadAllIncidentData,
  validateMaps,
  reloadConfig,
  getDeviceActions,
  getDevice,
  getDeviceDecrypted,
  getCredentials,
  getAccessToken,
  getQRCode,
  getBulkStateV2
};


function getAccessToken(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/device/" + device_serial + "/access_token")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const FileSaver = require('file-saver');
    const text = response.text;
    const data = text && JSON.parse(text);
    let blob = new Blob([JSON.stringify(data, null, 4)], {type: "text/plain;charset=utf-8"});
    FileSaver.saveAs(blob, device_serial + ".json")
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}


function getQRCode(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/device/" + device_serial + "/qr-code")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const FileSaver = require('file-saver');
    const base64Data = response.text;
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    FileSaver.saveAs(blob, device_serial + ".png")
    callback(response)
  })
  .catch(reject)
  .catch(errorHandling)
}


function getDeviceActions(device_serial, action_type, per_page, page, callback, reject) {
  return SuperAgent
  .get(api_root + "/device/actions")
  .query({device_serial})
  .query({action_type})
  .query({per_page})
  .query({page})
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getDevice(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/device/" + device_serial)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getDeviceDecrypted(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/device/" + device_serial + "/decrypted")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function deployDevice(device_serial, location_id, callback, reject) {
  return SuperAgent
  .post(api_root + "/device/" + device_serial + "/deploy")
  .send({location_id})
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getCredentials(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/device/" + device_serial + "/credentials")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getDeviceConfig(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/config")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getDeviceLogs(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/logs")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getDeviceEvents(device_serial, per_page, page, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/events")
  .query({per_page})
  .query({page})
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getErrorOverview(device_serial, prev_hours, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/error_overview/" + prev_hours)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function syncTreatments(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/treatments/sync")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function stopImmediately(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/stop_immediately")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function reloadConfig(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/reload_config")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function uploadAllIncidentData(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/upload_data/all")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function validateMaps(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/validate_maps")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function uploadIncidentData(device_serial, database_id, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/upload_data/" + database_id)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}



function getDeviceStateV2(serial_number, reject) {
  return SuperAgent
    .get(api_root + "/machine/v2/" + serial_number + "/state")
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      const text = response.text;
      const data = text && JSON.parse(text);
      return parseDeviceStateV2(data);
    })
    .catch(function(error) {
      return handleDeviceStateV2Error(error, reject);
    });
}

function handleDeviceStateV2Error(error, reject) {
  const response = error && error.response;
  const statusCode = response && response.statusCode;

  if (statusCode === 404) {
    return null;
  }

  if (statusCode === 422) {
    store.dispatch(alertActions.error("Invalid request to fetch state."));
    if (reject) {
      reject(error);
    }
    return;
  }

  if (statusCode === 500) {
    const body = response && response.body;
    const details = body && (body.detail || body.details || body.error);
    store.dispatch(alertActions.error(`Failed to fetching device state: ${details || response.text || "Something went wrong while fetching device state."}`));
    if (reject) {
      reject(error);
    }
    return;
  }

  if (reject) {
    reject(error);
  }
  errorHandling(error);
}



/**
 * @typedef {Object} RobotPlatformStateV2
 * @property {string} timestamp timestamp of the device state.
 * @property {string} serial_number
 * @property {"XENION_A6" | "XENION_CONNECT" | "LUMION_FIX"} device_type
 * @property {BatteryInfo | null} battery_info
 * @property {CurrentLocation | null} current_location current location of the device, or null if not available.
 * @property {"idle" | "prepared_to_start_task" | "preparing_task" | "executing_task" | "start_up" | "task_recovery" | "manual_interaction" | "error"} state
 * @property {string | null} error_code
 * @property {boolean} is_live whether the device is live or not.
 */

/**
 * 
 * @typedef {Object} DockingImplementStateV2
 * @property {string} timestamp timestamp of the device state.
 * @property {string} serial_number
 * @property {"DIV01"} device_type
 * @property {Array<ConnectedImplement | ConnectedHardware | ConnectedUnknownImplement> | null} connected_devices connected devices of the docking implement, or null if not available.
 * @property {"idle" | "prepared_to_start_task" | "preparing_task" | "executing_task" | "start_up" | "task_recovery" | "manual_interaction" | "error"} state
 * @property {string | null} error_code
 * @property {boolean} is_live whether the device is live or not.
 */ 
function parseDeviceStateV2(data) {
  /**
   * The type of the device.
   * @type {"XENION_A6" | "XENION_CONNECT" | "LUMION_FIX" | "DIV01" | "UVP01" | "UVP02" | "UVP04" | "UVP06" | "IDK01" | "SPR01" | "SCT01" | "BUG01"}
   */
  const device_type = data.device_type;

  if (['XENION_A6', 'XENION_CONNECT', 'LUMION_FIX'].includes(device_type))
    return parseRobotPlatformStateV2(data)
  else if (device_type === 'DIV01')
    return parseDockingImplementStateV2(data)
  else
    throw new Error(`Unsupported device type: ${device_type}`);
}

/**
 * @typedef {Object} BatteryInfo
 * @property {number | null} level - The battery level, or null if not available.
 * @property {"charging" | "discharging" | "critically_low" | "fully_charged" | "unknown" | "error"} state - The charging state.
 */

function parseBatteryInfo(data) {


  return {
    /**
     * The battery level of the device.
     * @type {number | null} The battery level of the device, or null if not available.
      */
     level : data.level || null,
     /**
      * The charging state of the device.
      * @type {"charging" | "discharging" | "critically_low" | "fully_charged" | "unknown" | "error"} 
      */
     state: data.state,
  }}


/**
 * @typedef {Object} CurrentLocation
 * @property {number} x - The x-coordinate.
 * @property {number} y - The y-coordinate.
 * @property {number} theta - The orientation.
 * @property {string | null} lane_id - The lane ID, or null if not available.
 * @property {string} map_id - The map ID.
 */

/**
 * @param {Object} data
 * @returns {CurrentLocation}
 */
function parseCurrentLocation(data) {
  return {
    x: data.x,
    y: data.y,
    theta: data.theta,
    lane_id: data.lane_id || null,
    map_id: data.map_id,
  }

}

/**
 * @param {Object} data
 * @returns {RobotPlatformStateV2}
 */
function parseRobotPlatformStateV2(data) {

  const batteryInfo = data.battery_info ? parseBatteryInfo(data.battery_info) : null;
  const currentLocation = data.current_location ? parseCurrentLocation(data.current_location) : null;
  
  return {
    timestamp: data.timestamp,
    serial_number: data.serial_number,
    device_type: data.device_type,
    battery_info: batteryInfo,
    current_location: currentLocation,
    state: data.state,
    error_code: data.error_code || null,
    is_live: data.is_live,
  };
}


/**
 * @param {Object} data
 * @returns {DockingImplementStateV2}
 */
function parseDockingImplementStateV2(data) {

  const connectedDevices = data.connected_devices ? parseConnectedDevices(data.connected_devices) : null


  return {
    timestamp: data.timestamp,
    serial_number: data.serial_number,
    device_type: data.device_type,
    connected_devices: connectedDevices,
    state: data.state,
    error_code: data.error_code || null,
    is_live: data.is_live,
  };
}



/**
 * @typedef {Object} ConnectedImplement
 * @property {string} serial_number
 * @property {"UVP01" | "UVP02" | "UVP04" | "UVP06" | "IDK01" | "SPR01" | "SCT01" | "BUG01"} device_type
 */ 


/**
 * @typedef {Object} ConnectedHardware
 * @property {string | null } serial_number
 * @property {"DBD01" | "DIL01" | "DSS01" | "DFB01" | "IDK01" } device_type
 */


/**
 * @typedef {Object} ConnectedUnknownImplement
 * @property {string | null } serial_number
 * @property {"unknown"} device_type
 */


/**
 * @param {Array<ConnectedImplement | ConnectedHardware | ConnectedUnknownImplement>} data
 * @returns {Array<ConnectedImplement | ConnectedHardware | ConnectedUnknownImplement>}
 */
function parseConnectedDevices(data) {
  return data.map(device => {
    return {
        serial_number: device.serial_number || null,
        device_type: device.device_type || null,}
  })
}

function parseImplementStateV2(data) {
  return data;
}

/**
 * Fetch the V2 state for one or more devices.
 *
 * Follows the cursor-based pagination of the endpoint
 * (`meta.pagination.has_more` / `meta.pagination.next_serial_number`)
 * and accumulates all pages before normalizing, so callers always
 * receive the complete state map.
 *
 * @param {string | Array<string>} [serial_number] - Optional serial number(s) to filter by.
 * @param {function(BulkDeviceStateMap)} callback - Called with the normalized state map on success.
 * @param {function(*)} [reject] - Optional callback invoked on error after the alert is shown.
 * @returns {SuperAgent.Request}
 */
export function getBulkStateV2(serial_number, callback, reject) {
  return fetchBulkStateV2Page(serial_number, undefined, [], callback, reject);
}

/**
 * Fetch a single page of the bulk device state endpoint and recurse
 * while the API reports more pages.
 *
 * @param {string | Array<string>} [serial_number] - Optional serial number(s) to filter by.
 * @param {string} [cursor] - Pagination cursor (`next_serial_number`) from the previous page.
 * @param {Array<BulkDeviceStateItem>} accItems - Items accumulated from previous pages.
 * @param {function(BulkDeviceStateMap)} callback
 * @param {function(*)} [reject]
 * @returns {SuperAgent.Request}
 */
function fetchBulkStateV2Page(serial_number, cursor, accItems, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/v2/state")
  .query({ serial_number: serial_number })
  .query({ next_serial_number: cursor })
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);

    const pageItems = (data && Array.isArray(data.data)) ? data.data : [];
    const items = accItems.concat(pageItems);

    const pagination = data && data.meta && data.meta.pagination;
    const hasMore = !!(pagination && pagination.has_more);
    const nextCursor = pagination && pagination.next_serial_number;

    // Guard against an API that reports has_more without advancing the cursor,
    // or returns an empty page, to avoid an infinite loop.
    if (hasMore && nextCursor && pageItems.length > 0) {
      return fetchBulkStateV2Page(serial_number, nextCursor, items, callback, reject);
    }

    callback(parseBulkDeviceStateV2({ data: items }))
  })
  .catch(function(error) {
      return handleDeviceBulkdStateV2Error(error, reject);
    });
}

/**
 * @typedef {Object} BulkDeviceStateItem
 * @property {string} serial_number
 * @property {boolean} is_live
 * @property {string} state 
 * @property {string | null} error_code
 * @property {number | null} battery_level
 * @property {string} timestamp
 */

/**
 * @typedef {Object} BulkDeviceStateResponse
 * @property {Array<BulkDeviceStateItem>} data
 * @property {Object} [meta]
 * @property {Object} [meta.pagination]
 * @property {boolean} [meta.pagination.has_more]
 * @property {string} [meta.pagination.next_serial_number]
 */

/**
 * A map of serial number to bulk device state item.
 * @typedef {Object.<string, BulkDeviceStateItem>} BulkDeviceStateMap
 */

/**
 * @param {BulkDeviceStateResponse} data
 * @returns {BulkDeviceStateMap}
 */
function parseBulkDeviceStateV2(data) {
  
  /**
   * @type {BulkDeviceStateMap}
   */
  const normalized = {}
  

  if (!data || !Array.isArray(data.data)) {
    return normalized
  }

  data.data.forEach(function (item) {
    normalized[item.serial_number] = {
      serial_number: item.serial_number,
      is_live: item.is_live,
      state: item.state,
      error_code: item.error_code || null,
      battery_level: item.battery_level || null,
      timestamp: item.timestamp
    }
  })

  return normalized
}

function handleDeviceBulkdStateV2Error(error, reject) {
  const response = error && error.response;
  const statusCode = response && response.statusCode;

  

  if (statusCode === 422) {
    store.dispatch(alertActions.error("Invalid request to fetch state of multiple devices."));
    if (reject) {
      reject(error);
    }
    return;
  }

  if (statusCode === 500) {
    const body = response && response.body;
    const details = body && (body.detail || body.details || body.error);
    store.dispatch(alertActions.error(`Failed to fetching state of multiple devices: ${details || response.text || "Something went wrong while fetching device state."}`));
    if (reject) {
      reject(error);
    }
    return;
  }

  if (reject) {
    reject(error);
  }
  errorHandling(error);
}

/**
 * Get's some live Xenion data of the device. This is information that comes via MQTT data events but contains 
 * "state" information.
 * @param {string} device_serial
 * @param {*} callback 
 * @param {*} reject 
 * @returns 
 */
function getDeviceXenionData(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/state_data")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}


function getDeviceSwVersion(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/sw_version")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getDeviceMapData(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/map_data")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}


function takeControl(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/take_control")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function releaseControl(device_serial, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/release_control")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function waitOnEvent(device_serial, event_name, callback, reject) {
  return SuperAgent
  .get(api_root + "/machine/" + device_serial + "/wait/" + event_name)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}
